import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogPortal,
    DialogOverlay,
} from "../../../../components/ui/Dialog";
import { Button } from "../../../../components/ui/Button";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { motion } from "framer-motion";
import usePartnerAwareNavigate from "../../../../hooks/usePartnerAwareNavigate";

interface InterviewCompleteDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onViewReport: () => void;
    onReturnHome: () => void;
}

export default function InterviewCompleteDialog({
    isOpen,
    onClose,
    onViewReport,
    onReturnHome,
}: InterviewCompleteDialogProps) {
    const navigate = usePartnerAwareNavigate();

    const handleReturnHome = async () => {
        onReturnHome();
    };

    const handleViewReport = async () => {
        onViewReport();
    };

    const handleContinue = async () => {
        // Store the target URL in sessionStorage
        // sessionStorage.setItem(
        //     "redirectAfterRefresh",
        //     "/dashboard/feedback/Survey Feedback"
        // );

        // // Refresh the page which will trigger the redirect in useEffect
        // window.location.href = "/dashboard/feedback/Survey Feedback";
        navigate("/feedback/Survey Feedback");
        window.location.reload();
    };

    return (
        <Dialog open={isOpen} onOpenChange={handleContinue}>
            <DialogPortal>
                <DialogOverlay className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm" />
                <DialogContent className="fixed left-[50%] top-[50%] z-50 grid w-full max-w-md translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-2xl duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-2xl">
                    <DialogHeader>
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            transition={{ duration: 0.3 }}>
                            <DialogTitle className="text-2xl font-bold text-gray-800 mb-1">
                                🎉 Nice work!
                            </DialogTitle>
                            <DialogDescription className="text-base text-gray-600">
                                You've completed this mock interview.
                            </DialogDescription>
                        </motion.div>
                    </DialogHeader>

                    <div className="flex flex-col items-start space-y-4">
                        <motion.div
                            className="w-32 h-32 self-center"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.2 }}>
                            <DotLottieReact
                                src="https://lottie.host/46e450df-6678-4da5-be34-1d9aae84569e/CYkf8XRMqg.lottie"
                                loop
                                speed={0.5}
                                autoplay
                            />
                        </motion.div>

                        <motion.div
                            className="space-y-3 w-full"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.3 }}>
                            <div className="space-y-3">
                                <div className="p-3 bg-blue-50 rounded-lg border border-blue-100">
                                    <p className="text-gray-700 space-y-1 text-sm">
                                        <span className="block font-medium">
                                            🧠 Your personalized performance
                                            report is now being generated.
                                        </span>
                                        <span className="block text-blue-600">
                                            ⏳ This may take 2-3 minutes.
                                        </span>
                                    </p>
                                </div>

                                <div className="p-3 bg-amber-50 rounded-lg border border-amber-100">
                                    <p className="text-amber-700 text-sm">
                                        <span className="block font-medium">
                                            📌 You will receive an email when
                                            your report is ready.
                                        </span>
                                        Or check the{" "}
                                        <span className="font-semibold">
                                            [Report Tab]
                                        </span>{" "}
                                        in a few minutes.
                                    </p>
                                </div>

                                <div className="p-3 bg-emerald-50 rounded-lg border border-emerald-100">
                                    <p className="text-emerald-700 text-sm">
                                        <span className="block font-medium">
                                            👉 Want to keep practicing without
                                            limits?
                                        </span>
                                        <a
                                            href="/subscription"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 font-semibold hover:underline inline-block mt-1">
                                            [View Subscription Options]
                                        </a>
                                    </p>
                                </div>
                            </div>
                        </motion.div>

                        <motion.div
                            className="flex gap-3 w-full justify-center pt-2"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ delay: 0.4 }}>
                            <Button
                                variant="outline"
                                onClick={handleContinue}
                                style={{
                                    backgroundColor: "var(--color-primary)",
                                    color: "white",
                                }}
                                className="min-w-[130px] h-10 text-sm">
                                Continue
                            </Button>
                            {/* <Button
                variant="outline"
                onClick={handleReturnHome}
                className="min-w-[130px] h-10 text-sm hover:bg-gray-100 transition-colors"
              >
                Back to Homepage
              </Button>
              <Button
                onClick={handleViewReport}
                className="min-w-[130px] h-10 text-sm"
                style={{
                  backgroundColor: "var(--color-primary)",
                  color: "white",
                }}
              >
                Go to Report Tab
              </Button> */}
                        </motion.div>
                    </div>
                </DialogContent>
            </DialogPortal>
        </Dialog>
    );
}
